var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 13.2L3.2 13.2C2.5376 13.2 2 12.6624 2 12L2 4.00005C2 3.33765 2.5376 2.80005 3.2 2.80005L12.8 2.80005C13.4624 2.80005 14 3.33765 14 4.00005L14 12C14 12.6624 13.4624 13.2 12.8 13.2Z",
    stroke: "#DEE1E6",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 5.19995L7.99961 8.79995L12.3996 5.19995",
    stroke: "#DEE1E6",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail1);
export default __webpack_public_path__ + "static/media/mail-1.e85e134138c47214bf94d15f4ee6cb6a.svg";
export { ForwardRef as ReactComponent };